import { h } from 'preact'
import { message, Message } from '../../../../lib/intl/Message'
import {
  isPartiValgResultat,
  isValgResultat,
  PartiValgResultat,
  ValgResultat
} from '../../../domain'

import styles from './WidgetFooter.module.css'
import { createUrlFor } from '../../../routes'
import { useLocale } from '../../../../lib/intl/IntlProvider'

type Props = {
  resultat: ValgResultat | PartiValgResultat
  valgtype: 'kommune' | 'fylke'
}

export function WidgetFooter({ resultat, valgtype }: Props) {
  const locale = useLocale()
  const valg =
    valgtype === 'kommune'
      ? message('widget-status-kommunevalg')
      : message('widget-status-fylkesvalg')

  if (isValgResultat(resultat)) {
    const prosent = resultat.opptalt ? resultat.opptalt.forelopig : 0

    return (
      <div class={styles.widgetFooter}>
        <a href={createUrlFor(resultat.geografi, locale)}>
          {resultat.resultatType === 'Prognose' && (
            <Message id="widget-status-prognose" values={{ valg, prosent }} />
          )}
          {resultat.resultatType === 'PrognoseOverstyring' && (
            <Message id="widget-status-prognoseoverstyring" values={{ valg, prosent }} />
          )}
          {resultat.resultatType === 'Resultat' && (
            <Message id="widget-status-resultat" values={{ valg, prosent }} />
          )}
        </a>
      </div>
    )
  } else if (isPartiValgResultat(resultat)) {
    return (
      <div class={styles.widgetFooter}>
        <a href={createUrlFor(resultat.parti, locale)}>
          <Message id={'widget-status-parti'} values={{ valg }} />
        </a>
      </div>
    )
  } else {
    return null
  }
}
